import { Box, Flex, VStack } from '@chakra-ui/react';
import { StepTitle } from '../step-title';
import { NumberedStep } from '../numbered-step';

export const HdmiCableStep: React.FC = () => {
  return (
    <Flex
      direction="column"
      align="center"
      minH="100vh"
      px={6}
      pt={16}
      pb={24}
      bg="white"
      overflowY="auto"
    >
      <VStack gap={5} maxW="500px" w="full">
        <StepTitle stepNumber={6} title="Connect HDMI Cable & Extend Tripod Pole" />

        {/* Instructions */}
        <Box
          w="full"
          p={5}
          bg="gray.50"
          borderRadius="xl"
          border="1px solid"
          borderColor="gray.200"
        >
          <VStack align="flex-start" gap={2}>
            <NumberedStep number={1}>
              Plug HDMI cable into camera
            </NumberedStep>
            <NumberedStep number={2}>
              Begin extending tripod pole upward
            </NumberedStep>
            <NumberedStep number={3}>
              Secure loose cable at top with cable twist (1)
            </NumberedStep>
            <NumberedStep number={4}>
              Continue extending pole to desired height
            </NumberedStep>
            <NumberedStep number={5}>
              Secure loose cable with remaining cable twists at middle and
              bottom (2)
            </NumberedStep>
            <NumberedStep number={6}>
              Plug HDMI into encoder
            </NumberedStep>
            <NumberedStep number={7}>
              Confirm live vision (no graphics) on encoder screen (allow up to 5
              seconds)
            </NumberedStep>
            <NumberedStep number={8}>
              Rotate the tripod pole left or right to centre the action
            </NumberedStep>
          </VStack>
        </Box>

        {/* Diagram */}
        <Box w="full" borderRadius="xl" overflow="hidden">
          <img
            src={`${import.meta.env.BASE_URL}images/hdmi-cable.webp`}
            alt="HDMI cable connection instructions"
            style={{ width: '100%', height: 'auto' }}
          />
        </Box>
      </VStack>
    </Flex>
  );
};
